<div mat-dialog-title>
  <h2>{{'group-management.join_class_title' | translate}}</h2>
  <button class="close"
    (click)="dialogRef.close()"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<mat-dialog-content>

    <h3>
        <span>{{title | translate}}</span>
        @if (finish && getClassInfo) {
            <span>{{titleGroup}}</span>
        }
    </h3>

    @if (!finish) {
        <div class="mb-24"
            fxLayout="row"
            fxLayoutAlign="start start">
            <mat-form-field fxFlex>
                <mat-label>{{'groups-management.code_class' | translate}}</mat-label>
                <input matInput [formControl]="controlCode">
            </mat-form-field>
        </div>
        @if (!classExist && !classError) {
            @if (getClassInfo?.name) {
                <div>{{'groups-management.class_name' | translate}} : {{getClassInfo.name}}</div>
            }
            @if (getClassInfo?.institution) {
                <div>{{'groups-management.institution' | translate}} : {{getClassInfo.institution}}</div>
            }
        }
        @if (state === 'start') {
            @if (classExist) {
                <div>{{'groups-management.class_already_joined' | translate}}</div>
            }
            @if (classError) {
                <div>{{'groups-management.code_class_error' | translate}}</div>
            }
        }
    }

</mat-dialog-content>

<mat-dialog-actions>
  @if (getClassInfo && !finish) {
    <button
      (click)="joinClass()"
      mat-raised-button
    class="mat-accent">{{'group-management.join_class_confirm' | translate}}</button>
  }

  @if (!getClassInfo && !finish && !classExist) {
    <button
      [disabled]="disableTest"
      (click)="testCode()"
      mat-raised-button
    class="mat-accent">{{'generic.test' | translate}}</button>
  }

  @if (!finish) {
    <button
      (click)="reset()"
      mat-raised-button
    class="mat-accent">{{'generic.cancel' | translate}}</button>
  }

  @if (finish && !classError) {
    <button
      (click)="dialogRef.close()"
      mat-raised-button
    class="mat-accent">{{'generic.close' | translate}}</button>
  }
</mat-dialog-actions>